export default {"src":"/_next/static/media/technologies-logo-3.4a232b76.svg","height":86,"width":86,"blurWidth":0,"blurHeight":0};